<template>
    <div>
        <el-carousel :height="computeHeight">
            <el-carousel-item v-for="(item, index) in sliders" :key="index">
                <el-image
                    class="slider_img"
                    :src="item.img"
                    fit="cover"></el-image>
            </el-carousel-item>
        </el-carousel>
        <!-- 公司简介 -->
        <div class="company_intro_root">
            <div class="company_intro_container">
                <el-row :gutter="20">
                    <el-col :xs="24" :sm="16">
                        <div class="container_v">
                            <div class="container_h align_center">
                                <div class="module_title">COMPANY PROFILE</div>
                                <div v-if="false" class="v_divider"></div>
                                <div v-if="false" class="module_title_c">COMPANY PROFILE</div>
                            </div>
                            <div class="module_title_s"></div>
                            <div class="v_company_intro_content">
                                {{value_company_intro}}
                            </div>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <div class="container_h container_h_r align_center">
                            <img :src="img_thumb_company_intro" style="width: 80%;height: auto;border: 0;"/>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <!-- 短信业务介绍 -->
        <div class="company_sms_root">
            <div class="company_sms_container">
                <div class="container_v">
                    <div class="container_h align_center">
                        <div class="module_title">SMS SERVICE INTRODUCTION</div>
                        <div v-if="false" class="v_divider"></div>
                        <div v-if="false" class="module_title_c">SMS SERVICE INTRODUCTION</div>
                    </div>
                    <div class="module_title_s"></div>
                    <div class="v_sms_intro_content">
                        {{value_sms_intro}}
                    </div>
                    <el-row :gutter="20">
                        <el-col v-for="item in module_sms" style="margin-top: 40px;" v-bind:key="item.img" :xs="24" :sm="24" :md="12">
                            <div class="sms_module">
                                <div class="sms_module_thumb">
                                    <div class="sms_module_img">
                                        <img :src="item.img" style="width: 100%;max-height: 200px;;border: 0;">
                                    </div>
                                    <div class="sms_module_title">
                                        <div class="title">{{item.title}}</div>
                                        <div class="secondTitle">{{item.secondTitle}}</div>
                                    </div>
                                </div>
                                <div class="sms_module_content">{{item.content}}</div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <!-- 外呼系统介绍 -->
        <div class="company_intro_root" style="padding-bottom: 80px;">
            <div class="company_intro_container">
                <div class="container_v">
                    <div class="container_h align_center">
                        <div class="module_title">OUTGOING CALL SYSTEM</div>
                        <div v-if="false" class="v_divider"></div>
                        <div v-if="false" class="module_title_c">OUTGOING CALL SYSTEM</div>
                    </div>
                    <div class="module_title_s"></div>
                    <div class="v_company_intro_content">
                        Our outbound system can provide enterprise customers with customer contact scenarios of the three core operating processes of "business, marketing and service". By accessing SUPER TECH's intelligent customer contact platform, customers can use products and services such as call center, online customer service, work order system, enterprise micro assistant, text robot, outbound robot, intelligent quality inspection, PaaS cloud communication, communication center, etc., and can seamlessly connect with customers' own business systems. The whole business is run on a set of platforms, the process is highly collaborative, and the data is completely unified, which greatly improves the operating efficiency of the enterprise, optimizes the customer experience, and reduces the operating cost.
                    </div>
                    <div>
                        <el-row :gutter="20">
                            <el-col v-for="item in module_outcall" style="margin-top: 40px;" v-bind:key="item.img" :xs="24" :sm="24" :md="8">
                                <div class="outcall_module">
                                    <div class="outcall_module_img">
                                        <img :src="item.img" style="width: 40px;height: 40px;border: 0;">
                                        <div class="title">{{item.title}}</div>
                                    </div>
                                    <div class="outcall_module_content">{{item.content}}</div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Index',
        data() {
            return {
                sliders: [],
                img_thumb_company_intro: require('../../static/index/img_index_thumb_company_intro.jpg'),
                value_company_intro: 'We are a professional communication enterprise engaged in business SMS and voice services, we have many years of mobile communication technology research and development experience, and committed to SMS and voice application technology development, product sales and system integration, to provide our customers with a full range of SMS and voice application solutions.',
                value_sms_intro: 'For large, small and medium-sized enterprises and financial customers based on China Mobile, China Telecom, China Unicom, international operators reminder, communication, notification, urging, marketing and other SMS services. Includes the following services:',
                module_sms: [
                    {
                        img: require('../../static/index/img_index_thumb_sms_intro_1.jpg'),
                        title: 'SMS verification code',
                        secondTitle: 'Speed verification must be reached in five seconds',
                        content: 'Voice and text verification code, suitable for user registration, login verification, password retrieval, payment authentication, etc'
                    },
                    {
                        img: require('../../static/index/img_index_thumb_sms_intro_2.jpg'),
                        title: 'Marketing SMS',
                        secondTitle: 'Precision marketing screening target customers',
                        content: 'Member service, festival promotion, business promotion, exhibition, job fair invitation'
                    },
                    {
                        img: require('../../static/index/img_index_thumb_sms_intro_3.jpg'),
                        title: 'Short message notification',
                        secondTitle: 'Carrier resource reserve',
                        content: 'Holiday wishes, meeting notice, logistics notice, system notice, early warning notice, etc'
                    },
                    {
                        img: require('../../static/index/img_index_thumb_sms_intro_4.jpg'),
                        title: 'Interface SMS',
                        secondTitle: 'Data encryption, information security',
                        content: 'Websites, apps and system software can realize SMS triggering by accessing the SMS network interface'
                    }
                ],
                module_outcall: [
                    {
                        img: require('../../static/index/icon_index_thumb_outcall_intro_1.png'),
                        title: 'Flexible access',
                        content: 'Our voice lines support PSTN and VoIP two lines, with stable communication quality, safe communication guarantee characteristics.'
                    },
                    {
                        img: require('../../static/index/icon_index_thumb_outcall_intro_2.png'),
                        title: 'System comprehensive',
                        content: 'Our outbound calling system can be used online through SAAS, and also supports user independent deployment to meet the individual needs of customers.'
                    },
                    {
                        img: require('../../static/index/icon_index_thumb_outcall_intro_3.png'),
                        title: 'Intelligent service',
                        content: 'Based on years of operating experience and artificial intelligence technology, the company provides customers with intelligent outbound services and quality inspection services, which can achieve accurate outbound calls, robot agents and intelligent quality inspection and other application scenarios.'
                    }
                ],
                carousel_height: '450px',
            }
        },
        created() {
            sessionStorage.setItem('language', 'en');
        },
        methods: {},
        mounted() {
            this.sliders = [
                {
                    img: require("../../static/index/banner01_en.jpg")
                }
            ]
        },
        computed: {
            //计算高度
            computeHeight() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 415) {
                    return '450px';
                } else {
                    return '250px';
                }
            },
            computeArrowImg() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 450) {
                    return require('../../static/other/arrow.png');
                } else {
                    return require('../../static/other/arrow_down.png');
                }
            }
        },
    }
</script>

<style scoped>

    .container_v {
        display: flex;
        flex-direction: column;
    }
    .container_h {
        display: flex;
        flex-direction: row;
    }
    .container_h_r {
        display: flex;
        flex-direction: row-reverse;
    }
    .justify_center {
        justify-content: center;
    }
    .align_center {
        align-items: center;
    }
    .module_title {
        color: #000000;
        font-size: 1.45em;
        font-weight: bold;
        letter-spacing: 3px;
    }
    .module_title_c {
        color: #1C5DDD;
        font-size: 0.85em;
        font-weight: bold;
        letter-spacing: 3px;
    }
    .v_divider {
        background-color: #1C5DDD;
        width: 2px;
        height: 15px;
        margin-left: 10px;
        margin-right: 10px;
    }
    .module_title_s {
        background-color: #1C5DDD;
        width: 90px;
        height: 7px;
        margin-top: 10px;
    }

    .company_intro_root {
        width: 100%;
        background-color: white;
    }
    .company_intro_container {
        width: 70%;
        margin: auto;
        padding-top: 60px;
        padding-bottom: 60px;
    }
    .v_company_intro_content {
        margin-top: 40px;
        font-size: 16px;
        text-indent: 32px;
        color: #0E1228;
        line-height: 32px;
    }

    .company_sms_root {
        width: 100%;
        background-color: #F6F6F6;
    }
    .company_sms_container {
        width: 70%;
        margin: auto;
        padding-top: 60px;
        padding-bottom: 60px;
    }
    .v_sms_intro_content {
        margin-top: 40px;
        font-size: 16px;
        text-indent: 32px;
        color: #0E1228;
        line-height: 32px;
    }

    .sms_module {
        width: 100%;
        background-color: white;
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        height: auto;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
    }
    .sms_module_thumb {
        display: flex;
        flex-direction: column;
        position: relative;
    }
    .sms_module_title {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        transform: translate(-50%, -50%);
        color: white;
        text-align: center;
    }
    .sms_module_title .title {
        font-size: 32px;
        letter-spacing: 1px;
    }
    .sms_module_title .secondTitle {
        font-size: 18px;
        letter-spacing: 1px;
        margin-top: 20px;
    }
    .sms_module_content {
        min-height: 130px;
        margin-top: 10px;
        font-size: 16px;
        text-indent: 32px;
        line-height: 30px;
        padding: 20px;
    }

    .outcall_module {
        width: 100%;
        background-color: white;
        border-radius: 6px;
        border: 1px solid #0000003a;
        height: auto;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .outcall_module .outcall_module_img {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 120px;
    }
    .outcall_module .outcall_module_img .title {
        font-size: 20px;
        letter-spacing: 1px;
        color: #0E1228;
        font-weight: bold;
        margin-left: 10px;
    }
    .outcall_module_content {
        min-height: 290px;
        margin-top: 10px;
        font-size: 16px;
        text-indent: 32px;
        line-height: 30px;
        padding: 20px;
    }

    .slider_img {
        height: 450px;
        width: 100%;
    }

    /* 屏幕设备适配 max-device-width: 400px */
    @media screen and (max-device-width: 415px) {
        .slider_img {
            height: 250px;
            width: 100%;
        }
    }
</style>